import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'

const OAuthServiceContext = createContext(undefined)

const OAuthServiceProvider = ({children, oauthApiHost}) => {
  return (
    <ResourceApiServiceProvider
      Context={OAuthServiceContext}
      host={oauthApiHost}
      valueCallback={(axios) => ({
        createAccessToken: async (payload) => {
          const {data} = await axios.post(`/auth/token`, payload)
          return data
        },
        createAuthorizationCode: async (payload) => {
          const {data} = await axios.post(`/auth/codes`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

OAuthServiceProvider.propTypes = {
  children: PropTypes.any,
  oauthApiHost: PropTypes.string.isRequired
}

const useOAuthServiceProvider = () => {
  const context = useContext(OAuthServiceContext)
  if (context === undefined) {
    throw new Error('OAuthServiceContext was not provided. Make sure your component is a child of the OAuthServiceProvider.')
  }
  return context
}

export {OAuthServiceProvider, useOAuthServiceProvider}
